import moment from "moment";

const dateTimeFormat = 'DD.MM.YYYY HH:mm:ss';
const dateFormat = 'DD-MM-YYYY';

export function formatDate(date) {
    if (!date)
        return date;
    return moment(date).local().format(dateFormat);
}

export function formatDateTime(date) {
    if (!date)
        return date;
    return moment(date).local().format(dateTimeFormat);
}

export function formatDateTimePeriod(date, isNow, useDefaultTz) {
    if (!date)
        return date;

    date = useDefaultTz ? moment(date) : moment(date).local;

    if (isNow)
        return date.format("DD.MM.YYYY HH:mm (Сейчас)");

    return `${date.format("DD.MM.YYYY HH:mm")} - ${date.add(2, 'hours').format("HH:mm")}`;
}

export function parseTime(time) {
    const date = new Date();
    const [hours, minutes] = time.split(':');
    date.setHours(+hours);
    date.setMinutes(+minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}


// WEBPACK FOOTER //
// ./src/extensions/dateHelper.js